import {findIndex} from 'lodash';
import {
    FETCH_ENTITY_SANCTIONS_STARTED,
    FETCH_ENTITY_SANCTIONS_RESET,
    FETCH_ENTITY_SANCTIONS_BATCH_START,
    FETCH_ENTITY_SANCTIONS_SUCCESS_TOTAL,
    FETCH_ENTITY_SANCTIONS_SUCCESS_SINGLE,
    FETCH_ENTITY_SANCTIONS_FAILED,
    FETCH_ENTITY_SANCTIONS_FINISHED
} from "./SanctionsWarnings.actions";

const pageSize = 10;

export default function sanctionsWarnings(state = null, action) {
    let newCisIds;
    switch (action.type) {
        case FETCH_ENTITY_SANCTIONS_RESET:
            return {
                singleEntity: {
                    entityName: null,
                    companyId: null,
                    isLoading: false,
                    totalCount: null,
                    items: [],
                    cisIDs: [],
                    hasError: false,
                    isFinished: false
                }
            };

        case FETCH_ENTITY_SANCTIONS_STARTED:
            let cisIDs = [];
            for (let i = 0; i< action.payload.cisIDs.length; i++) {
                cisIDs.push({
                    id: action.payload.cisIDs[i],
                    start: 1,
                    end: pageSize,
                    totalCount: null
                })
            }
            return {
                singleEntity: {
                    cisIDs,
                    entityName: action.payload.entityName,
                    companyId: action.payload.companyId,
                    isLoading: true,
                    totalCount: null,
                    isFinished: false,
                    items: [],
                    hasError: false
                }
            };
        case FETCH_ENTITY_SANCTIONS_SUCCESS_TOTAL:
            const previousItems = state.singleEntity.items ? state.singleEntity.items : [];
            return {
                singleEntity: {
                    items: [ ...previousItems, ...action.payload.items ],
                    totalCount: action.payload.totalCount,
                    cisIDs: [...state.singleEntity.cisIDs],
                    entityName: state.singleEntity.entityName,
                    companyId: state.singleEntity.companyId,
                    isLoading: false,
                    hasError: state.singleEntity.hasError,
                    isFinished: state.singleEntity.isFinished
                }
            };

        case FETCH_ENTITY_SANCTIONS_SUCCESS_SINGLE:
            // Find cisID and update its state
            newCisIds = []
            state.singleEntity.cisIDs.forEach(cisId => {
                newCisIds.push(Object.assign({}, cisId));
            })
            let cisIdIndex = findIndex(newCisIds, {id:action.payload.cisId});
            newCisIds[cisIdIndex].totalCount = action.payload.totalCount;
            newCisIds[cisIdIndex].isLoading = false;
            newCisIds[cisIdIndex].start = newCisIds[cisIdIndex].end + 1;
            newCisIds[cisIdIndex].end = newCisIds[cisIdIndex].end + pageSize;

            return {
                singleEntity: {
                    ...state.singleEntity,
                    cisIDs: newCisIds,
                    entityName: state.singleEntity.entityName,
                    companyId: state.singleEntity.companyId
                }
            };

        case FETCH_ENTITY_SANCTIONS_FAILED:
            // TODO: FAIL FOR EACH CISID
            newCisIds = [];
            state.singleEntity.cisIDs.forEach(cisId => {
                newCisIds.push(Object.assign({}, cisId));
            })
            let newState = state.singleEntity;
            if (action.payload && action.payload.cisId) {
                newCisIds[findIndex(newCisIds, { id: action.payload.cisId })].hasError = true;
                newCisIds[findIndex(newCisIds, { id: action.payload.cisId })].isLoading = false;
                newState.cisIDs = newCisIds;
            }
            return {
                singleEntity: {
                    ...newState,
                    hasError: true
                }
            };

        case FETCH_ENTITY_SANCTIONS_FINISHED:
            return {
                singleEntity: {
                    ...state.singleEntity,
                    isFinished: true
                }
            };
        case FETCH_ENTITY_SANCTIONS_BATCH_START:
            let cisIds = Object.assign([], state.singleEntity.cisIDs);
            if (action.payload && action.payload.cisIds) {
                action.payload.cisIds.forEach(cisId => {
                    let newCisId = Object.assign({}, cisIds[findIndex(cisIds, { id: cisId })]);
                    newCisId.isLoading = true;
                    newCisId.hasError = false;
                    cisIds[findIndex(cisIds, { id: cisId })] = Object.assign({}, newCisId);
                })
            } else {
                cisIds = cisIds.map(id => { return { ...id, isLoading: true, hasError: false } });
            }
            return {
                singleEntity: {
                    ...state.singleEntity,
                    cisIDs: cisIds,
                    isLoading: true
                }
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/scripts/containers/SanctionsWarnings/SanctionsWarnings.reducers.jsx